import DescriptionMobile from './description-mobile';

export { DescriptionMobile }
